import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus'
import { es_dateFormat } from 'constants/date'
import { arrayGroupBy } from 'helpers/filter'
import { IFilterRow, IFilterOption } from 'interfaces/filterProps'
import FilterRow from '../commons/filter-row'
import styles from './index.module.scss'

interface IAdvanceFilter {
  translations: any
  selectedData: IFilterRow[]
  columnsData: IFilterOption[]
  onChange: any
  onDelete: any
  onAddRow: any
  setLastGroup: any
  dateFormat?: string
}

const AdvanceFilter: React.FC<IAdvanceFilter> = ({ selectedData, columnsData, translations, onChange, onDelete, onAddRow, setLastGroup, dateFormat = es_dateFormat }) => {
  const [data, setData] = useState([] as any)

  useEffect(() => {
    setData(arrayGroupBy(selectedData, 'group'))
  }, [selectedData])

  useEffect(() => {
    setLastGroup(Math.max(...selectedData.map(({ group }: any) => group), 0))
  }, [data])

  const handleChange = (index: number, selectedData: any) => {
    const { input, type, values, group, async, additionalFields } = selectedData
    onChange({ index, input, type, values, group, async, additionalFields })
  }

  useEffect(() => {
    const list = document.getElementById('advanceFilters-container')
    if (list) {
      list.style.marginBottom = list.offsetHeight >= 451 ? '10px' : '-10px'
      list.style.marginRight = list.offsetHeight >= 451 ? '-15px' : '0'
    }
  }, [data])

  return (
    <div className={`${styles.container} rankmiTable-filters-advanceFilter`} id="advanceFilters-container">
      {data.map(({ data: filters, group }: any, groupIndex: number) => (
        <div className={`${styles.filterGroup} rankmiTable-filters-advanceFilter-groupContainer`} key={`filterGroup-${group}`}>
          {filters && !!filters.length ? (
            <div>
              <p className={styles.filterGroupTitle}>{`${translations.filterGroup} ${groupIndex + 1}`}</p>
              {filters.map((item: any, rowNumber: number) => (
                <div className={`${styles.filterGroupRow} rankmiTable-filters-advanceFilter-groupContainer-row`} key={`filterGroup-${group}-row-${item.index}`}>
                  <FilterRow
                    closeable={!!item.input || !!item.index}
                    compareTo={item.compareTo}
                    condition={item.condition}
                    dateFormat={dateFormat}
                    input={item.input}
                    inputOptions={columnsData}
                    operator={item.operator}
                    selectedData={item}
                    showGroupCondition={!rowNumber && filters.length > 1}
                    translations={translations}
                    onChange={(selectedData: IFilterRow) => handleChange(item.index, { ...selectedData, group, async: item.async, additionalFields: item.additionalFields })}
                    onDelete={() => onDelete(item.index)}
                  />
                </div>
              ))}
            </div>
          ) : (
            <div>
              <p className={styles.filterGroupTitle}>{`${translations.filterGroup} 1`}</p>
              <FilterRow
                closeable={false}
                inputOptions={columnsData}
                selectedData={selectedData}
                translations={translations}
                onChange={(data: IFilterRow) => handleChange(selectedData.length, { ...data, group })}
              />
            </div>
          )}
          <a className={styles.addRow} onClick={() => onAddRow(group)}>
            <FontAwesomeIcon icon={faPlus} /> {translations.addFilter}
          </a>
        </div>
      ))}
    </div>
  )
}

export default AdvanceFilter
